<ng-container *ngIf="project">  
  <ngx-form-customer title="Customer" [value]="$any(customer)" (valueChange)="customer = $any($event)" [enabled]="$any(customer) == null" [rsm]="$any(me)?.contact"></ngx-form-customer>
  <hr>
  <ngx-form-dropdown title="Business Unit" [(value)]="project.businessUnit" [options]="businessUnits" (valueChange)="filterMaterial($any($event))"></ngx-form-dropdown>
  <ngx-form-text title="Name" [(value)]="project.name"></ngx-form-text>
  <ngx-form-dropdown title="Material" [(value)]="project.material" [options]="materialOptions"></ngx-form-dropdown>
  <ngx-doc-form-filter-select
    [noBorder]="true" [separator]="'|'" [options]="baseProductOptions" [(value)]="project.baseProduct"
    title="Base product">
  </ngx-doc-form-filter-select>
  <div class="row">
    <div class="col-md-4">Offers:</div>
    <div class="col-md-8">
      <table class="nrk-table">
        <tr>
          <th>
            <ngx-document-of-selector
              [style]="{'left':'-20em','width':'70em'}"
              [businessId]="$any(customer)"
              (compilationChange)="onOfSelected($event)"
            ></ngx-document-of-selector>
          </th>
          <th>Issue Date</th><th>Quote #</th><th>RFQ #</th><th>Product</th><th style="text-align: right;">Quote Total Net</th>
        </tr>
        <tr *ngFor="let offer of arrangeOffers(); index as idx;">
          <td><button class="nrk-doc-button" (click)="removeOffer(idx)">-</button></td>
          <td>{{offer.issueDate | date : 'yyyy-MM-dd'}}</td>
          <td>{{offer.nameOverride ?? offer.code}}</td>
          <td>{{offer.rfqReference}}</td>
          <td>{{offer.product}}</td>
          <td style="text-align: right;">{{offer.totalNet | currency : offer.currency : 'symbol' : '1.2-2' : 'de'}}</td>
        </tr>
      </table>
    </div>
  </div>
  <hr>
  <ngx-form-dropdown title="Type" [(value)]="project.type" [options]="projectTypeMap"></ngx-form-dropdown>
  <ngx-form-dropdown title="Status" [(value)]="project.status" [options]="projectStatusMap"></ngx-form-dropdown>
  <ngx-form-dropdown title="Product Development" [(value)]="project.development" [options]="developmentOptions"></ngx-form-dropdown>

  <hr>
  <ngx-form-dropdown title="Unit" [(value)]="project.unit" [options]="unitOptions"></ngx-form-dropdown>
  <ngx-form-text title="Quantity" [(value)]="$any(project).quantity" *ngIf="project.unit != ProjectQuantityUnit.Disabled"></ngx-form-text>
  <ngx-form-text title="Price per Unit" [(value)]="$any(project).price" *ngIf="project.unit != ProjectQuantityUnit.Disabled"></ngx-form-text>
  <ngx-form-dropdown title="Currency" [(value)]="project.currency" [options]="currencies"></ngx-form-dropdown>
  <ngx-form-entry *ngIf="project.unit != ProjectQuantityUnit.Disabled" title="Business potential" [value]="($any(project).quantity * $any(project).price).toLocaleString('en-US') + ' ' + project.currency"></ngx-form-entry>
  <ngx-form-text *ngIf="project.unit == ProjectQuantityUnit.Disabled" title="Potential sales (per YEAR)" [(value)]="$any(project).potential"></ngx-form-text>

  <hr>

  <ngx-form-percentage title="Probability" [(value)]="$any(project).probability"></ngx-form-percentage>
  <ngx-form-percentage title="Share" [(value)]="$any(project).share"></ngx-form-percentage>
  <hr>
  <ngx-form-date title="Kickoff date" [(value)]="project.kickoff"></ngx-form-date>

  <ngx-form-date title="Estimated Offer Date" [(value)]="project.offerDate"></ngx-form-date>
  <ngx-form-date title="Estimated Order Date" [(value)]="project.orderDate"></ngx-form-date>
  <hr>
  <ngx-form-area title="Remark" [(value)]="project.description"></ngx-form-area>

  <hr>

  <label><strong>Milestones</strong></label>
  <ngx-form-list *ngIf="milestoneColumns != null"
                [columns]="milestoneColumns"
                [(value)]="project.milestones"
                (valueChange)="changeMilestones($event)"
                (editConfirm)="validateMilestones($event)"
  >
  </ngx-form-list>
  <hr>
  <ngx-form-connected-projects title="Projects" [(value)]="project.projects"></ngx-form-connected-projects>
  <hr>
  <ngx-form-module title="Show in Reports" [(value)]="project.showInReport"></ngx-form-module>
  <br>

  <div style="display:flex;align-items:center;justify-content:center">
    <div style="display:inline-block"><button class="btn btn-default btn-md" (click)="cancel()" [disabled]="isSaving">Cancel</button></div>
    <div style="display:inline-block"><button class="btn btn-primary btn-md" (click)="save()" [disabled]="isSaving">Update</button></div>
  </div>
</ng-container>